export const SET_SETTINGS='SET_SETTINGS'
export const SET_SETTINGS_SUCCESS='SET_SETTINGS_SUCCESS'
export const SET_SETTINGS_ERROR='SET_SETTINGS_ERROR'

export const SetSettings = (data) => ({
    type: SET_SETTINGS,
    payload: data
})